import { useState } from "react";
import Api from "../../service/Api";
import "../ForgotPassword/ForgotPassword.css";
import { useTranslation } from 'react-i18next'; 

function ResetPassword() {
  const { t } = useTranslation();
  const [senha, setSenha] = useState("");

  const token = new URLSearchParams(window.location.search).get("token");

  const handleSubmit = (e) => {
    e.preventDefault();
    Api.resetPassword(token, senha);
  };

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={handleSubmit}>
        <h2>{t('forgot-password')}</h2>
        <p>{t('forgot-password1')}</p>

        <input
          type="password"
          placeholder={t('forgot-password2')}
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
        />

        <button type="submit">{t('forgot-password3')}</button>

        <div className="auth-link">
          
        </div>
      </form>
    </div>
  );
}

export default ResetPassword;